module.exports = __webpack_public_path__ + "1_0_65/img/mobile.107fef4f.webp";